/**
 * @typedef {import('./PlayerSettings.types').InputArea} InputArea
 * @typedef {import('./PlayerSettings.types').VHPlayerOverlay} VHPlayerOverlay
 * @typedef {import('./PlayerSettings.types').ConversationControl} ConversationControl
 *  */

export const DefaultPlayerConfig = {
  inputArea: /**@type {InputArea} */ ('standard'),
  conversationControl: /**@type {ConversationControl} */ ('standard'),
  vhPlayerOverlay: /**@type {VHPlayerOverlay} */ ('standard'),
};
